import { useParams } from 'react-router-dom';
import { type LocalModelWithPermissionsSpecsFragment } from '../../../api/fragments/LocalModelWithPermissionsSpecs';
import { useGetVehicleQuery } from '../../../api/queries/getVehicle';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import SubmodelDetailsPage from './SubmodelDetailsPage';

const SubmodelDetails = () => {
    const { submodelId } = useParams<{ submodelId: string }>();

    const { data, loading } = useGetVehicleQuery({
        fetchPolicy: 'network-only',
        variables: { id: submodelId },
    });

    const submodel = data?.vehicle as LocalModelWithPermissionsSpecsFragment;

    if (!submodel && loading) {
        return <LoadingElement />;
    }

    if (!submodel) {
        return <NotFoundResult />;
    }

    return <SubmodelDetailsPage submodel={submodel} />;
};

export default SubmodelDetails;
